var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.loader}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),_c('NonAutorise',{directives:[{name:"show",rawName:"v-show",value:(_vm.PageNonAutorise),expression:"PageNonAutorise"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }